import Vue from 'vue';
// 注册全局指令
import transferBlank from '../directives/transfer-blank';

Vue.directive('transfer-blank', transferBlank);